import * as Sentry from '@sentry/nextjs';

const environment = (process.env.BASE_URL || 'http://local-dev').split('//')[1].replace(/\s+|\//g,"");
Sentry.init({
    dsn: process.env.SENTRY_DSN,
    tracesSampleRate: 0.5,
    environment,
});
